import { createActionsHook } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { ExpectationEntity } from '../../Risks/models/Risk';

const actionConfig = { resourcePath: '/risks/expectations' };

export const riskExpectationsActions = createRestActions<ExpectationEntity>(actionConfig);

export const RiskExpectationsStore = createRestStore<ExpectationEntity>({
  name: 'risk-expectations-store',
  actions: riskExpectationsActions,
  actionConfig,
  containerDisplayName: 'risk-expectations-container',
  onInitAction: null,
});

export const useRiskExpectationsData = createDataHook(RiskExpectationsStore);
export const useRiskExpectationsIsLoading = createLoadingHook(RiskExpectationsStore);
export const useRiskExpectationsActions = createActionsHook(RiskExpectationsStore);
export const didRiskExpectationsMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
